import { Component, h, Prop, Element, Host } from "@stencil/core"
import { IconSize } from "./types"
import { FlipDirection } from "../../core/types/types"
import { getAppearance } from "../../core/helpers/webcomponent-helpers"
import { IconName } from "../../core/types/icon-names"

@Component({
  tag: "sdx-icon",
  styleUrl: "icon.scss",
  shadow: true,
})
export class Icon {
  @Element() public el!: HTMLSdxSearchElement

  /**
   * Name of the SDX icon (e.g. "icon-clear-circle").
   */
  @Prop() public iconName?: IconName

  /**
   * SDX predefined color class.
   */
  @Prop() public colorClass: string = ""

  /**
   * The dimension of the icon.
   * If omitted, the icon will adapt to the current font-size.
   */
  @Prop() public size: IconSize

  /**
   * Mirror the icon.
   */
  @Prop() public flip: FlipDirection = "none"

  /**
   * Hide the icon (animated).
   */
  @Prop() public hidden: boolean = false

  /**
   * Description text read by the screen reader.
   */
  @Prop() public srHint: string = ""

  /**
   * Apply a gradient.
   */
  @Prop() public gradient: boolean = false

  private getClassNames() {
    return {
      icon: true,
      [this.iconName ?? ""]: true,
      [this.colorClass]: true,
      [`icon--s${this.size}`]: !!this.size,
      [`icon--gradient`]: this.gradient,
    }
  }

  public render() {
    return (
      <Host class={{ size: !!this.size }}>
        <sdx-animation animationName={this.hidden ? "scale-out" : "scale-in"}>
          <sdx-flip direction={this.flip} class={getAppearance(this.el)}>
            <span class={this.getClassNames()} aria-hidden="true"></span>
            {this.srHint !== "" && <span class="sr-only">{this.srHint}</span>}
          </sdx-flip>
        </sdx-animation>
      </Host>
    )
  }
}
